<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner inner-bg11">
    <div class="container">
        <div class="inner-title">
            <h3>Reset Password</h3>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li><i class='bx bxs-chevrons-right'></i></li>
                <li style="color: #FEAE1D;">Reset Password</li>
            </ul>
        </div>
    </div>
</div>

<section class="sign-up-area ptb-100">
    <div class="container">
        <div class="contact-wrap-form sign-in-width">
            <!-- Step 1: Email Input -->
            <div class="scetion-title text-center" *ngIf="currentStep === 1">
                <span style="color: #C71D1D;">Reset Password</span>
                <h2>Reset Your Password!</h2>
                <p class="recover-text">Enter the email of your account to reset the password. Then you will receive an OTP to email to reset the password.</p>
                
                <form [formGroup]="resetForm" (ngSubmit)="resetPassword()">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <input class="form-control" type="email" name="email" formControlName="email" placeholder="Enter Your Email">
                                <div *ngIf="resetForm.get('email')?.hasError('required') && resetForm.get('email')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Email is required
                                </div>
                                <div *ngIf="resetForm.get('email')?.hasError('email') && resetForm.get('email')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Enter a valid email address
                                </div>
                            </div>
                        </div>

                        <div class="col-12 text-center">
                            <button class="btn btn-primary" type="submit" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Send OTP
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Step 2: OTP Verification -->
            <div class="scetion-title text-center" *ngIf="currentStep === 2">
                <span style="color: #C71D1D;">Verify OTP</span>
                <h2>Enter Verification Code</h2>
                <p class="recover-text">We've sent a 6-digit code to <strong>{{resetForm.value.email}}</strong></p>
                
                <form [formGroup]="otpCodeForm" (ngSubmit)="verifyOtp()">
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="otp-input-group">
                                <input type="text" maxlength="1" (input)="moveToNext($event, 1)" #otp1>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 2)" #otp2>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 3)" #otp3>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 4)" #otp4>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 5)" #otp5>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 6)" #otp6>
                            </div>
                            <input type="hidden" formControlName="otp_code">
                            <div *ngIf="otpCodeForm.get('otp_code')?.hasError('required')" class="text-danger text-small text-center mt-2">
                                OTP is required
                            </div>
                        </div>

                        <div class="col-12 text-center mt-4">
                            <button class="btn btn-primary me-2" type="submit" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Verify
                            </button>
                            <button class="btn btn-outline-secondary" type="button" (click)="resendOtp()" [disabled]="isResending">
                                <span *ngIf="isResending" class="spinner-border spinner-border-sm me-1"></span>
                                Resend OTP
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Step 3: New Password -->
            <div class="scetion-title text-center" *ngIf="currentStep === 3">
                <span style="color: #C71D1D;">New Password</span>
                <h2>Create New Password</h2>
                <p class="recover-text">Your new password must be different from previous used passwords.</p>
                
                <form [formGroup]="updatePasswordForm" (ngSubmit)="updatePassword()">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>New Password</label>
                                <input class="form-control" type="password" formControlName="password" placeholder="Enter new password">
                                <div *ngIf="updatePasswordForm.get('password')?.hasError('required') && updatePasswordForm.get('password')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Password is required
                                </div>
                                <div *ngIf="updatePasswordForm.get('password')?.hasError('minlength') && updatePasswordForm.get('password')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Password must be at least 8 characters
                                </div>
                            </div>
                        </div>

                        <div class="col-12 mt-3">
                            <div class="form-group">
                                <label>Confirm Password</label>
                                <input class="form-control" type="password" formControlName="password_confirmation" placeholder="Confirm new password">
                                <div *ngIf="updatePasswordForm.get('password_confirmation')?.hasError('required') && updatePasswordForm.get('password_confirmation')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Please confirm your password
                                </div>
                                <div *ngIf="updatePasswordForm.hasError('mismatch')" class="text-danger text-small ps-3 mt-0">
                                    Passwords do not match
                                </div>
                            </div>
                        </div>

                        <div class="col-12 text-center mt-4">
                            <button class="btn btn-primary" type="submit" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Update Password
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Step 4: Success Message -->
            <div class="scetion-title text-center" *ngIf="currentStep === 4">
                <div class="success-animation">
                    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                    </svg>
                </div>
                <h2>Password Changed!</h2>
                <p class="recover-text">Your password has been updated successfully.</p>
                <p>You'll be redirected to home page shortly...</p>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>